import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Sidebar from "../../components/SidebarQA/Sidebar";
import { GetQADashboard } from "../../apis/DashboardAPI";
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartTooltip,
} from "@progress/kendo-react-charts";
import "hammerjs";
import { GetNotifications } from "../../apis/NotificationAPI";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";

export default function Dashboard() {
  const {user} = useSelector((state) => state.auth);
  const [initialReviewCount, setInitialReviewCount] = useState(0);
  const [initialReviewedCount, setInitialReviewedCount] = useState(0);
  const [prelimReviewCount, setPrelimReviewCount] = useState(0);
  const [prelimReviewedCount, setPrelimReviewedCount] = useState(0);
  const [reopenedCount, setReopenedCount] = useState(0);
  const [notificationList, setNotificationList] = useState([]);

  async function GetUserNotifications() {
    var result = await GetNotifications();
    var data = result.data;
    setNotificationList(data.slice(0, 4));
  }

  useEffect(() => {
    async function GetOrderData() {
      var result = await GetQADashboard(user.userid);
      var data = result.data;
      setInitialReviewCount(
        data.filter((d) => d.order_status_id === 9)[0].order_count
      );
      setInitialReviewedCount(
        data.filter((d) => d.order_status_id === 10)[0].order_count
      );
      setPrelimReviewCount(
        data.filter((d) => d.order_status_id === 11)[0].order_count
      );
      setPrelimReviewedCount(
        data.filter((d) => d.order_status_id === 12)[0].order_count
      );
      setReopenedCount(
        data.filter((d) => d.order_status_id === 13)[0].order_count
      );
    }
    GetOrderData();
    GetUserNotifications();
  }, []);

  window.addEventListener("notification", () => {
    GetUserNotifications();
  });

  const series = [
    { category: "In Initial Review", value: initialReviewCount },
    { category: "Initial Reviewed", value: initialReviewedCount },
    { category: "Prelim In Review", value: prelimReviewCount },
    { category: "Prelim Reviewed", value: prelimReviewedCount },
    { category: "Reopened Order", value: reopenedCount },
  ];

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <h1>Dashboard</h1>
                <Row>
                  <Col xl={4} lg={12} md={12} className="mb-5">
                    <div
                      cardinfo="data-Orders"
                      className="cards card investigator-dashboard-car"
                    >
                      <div className="cards-head">
                        <div className="cards-title h5">Orders</div>
                      </div>
                      <div className="cards-body">
                        <div className="cards-text">
                          <div className="cards-list-group">
                            <div className="cards-list-item">
                              <span className="text-blue">Initial Review:</span>{" "}
                              {initialReviewCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-gray">
                                Initial Reviewed:
                              </span>{" "}
                              {initialReviewedCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-sky">
                                Prelim In Review:
                              </span>{" "}
                              {prelimReviewCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-pink">
                                Prelim Reviewed:
                              </span>{" "}
                              {prelimReviewedCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-pink">Reopened:</span>{" "}
                              {reopenedCount}
                            </div>
                          </div>
                        </div>
                      </div>
                      <Link to="/QA/Orders" className="cards-link">
                        View All Orders
                      </Link>
                    </div>
                  </Col>
                  <Col xl={4} lg={12} md={12} className="mb-5">
                    <Card>
                      <Card.Body>
                        <Chart>
                          <ChartLegend position="bottom" />
                          <ChartTooltip visible={true} />
                          <ChartSeries>
                            <ChartSeriesItem
                              type="pie"
                              data={series}
                              field="value"
                              categoryField="category"
                            >
                              <ChartSeriesItemTooltip format="{0}" />
                            </ChartSeriesItem>
                          </ChartSeries>
                        </Chart>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Row className="mt-5">
                  <Col xl={8} lg={12}>
                    <Card className="notifications-card">
                      <div className="card-head">
                        <div className="card-title h5">Notifications</div>
                      </div>
                      <ul className="notifications-list max-no-list">
                        {notificationList.map((item) =>
                          item.order_status_name === "Initial Review" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has sent Order number{" "}
                                <Link
                                  to={`/QA/OrderDetails?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>'s{" "}
                                initial report for review.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Prelim In Review" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has sent Order number{" "}
                                <Link
                                  to={`/QA/OrderDetails?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>'s{" "}
                                prelim report for review.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Reopened" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                Order number{" "}
                                <Link
                                  to={`/QA/OrderDetails?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                has been reopened for editing.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : (
                            ""
                          )
                        )}
                      </ul>
                      <Card.Link href="/QA/Notifications">View All</Card.Link>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
